import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AnatomicalSideLabelPipe, BaseMaLtTableComponent } from '../../../shared';


/**
* Recap table of Lateral image of PDF print.
*/
@Component({
	selector: 'prt-ma-lt-table',
	templateUrl: './prt-ma-lt-table.component.html',
	imports: [
		AnatomicalSideLabelPipe
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class PrtMaLtTableComponent extends BaseMaLtTableComponent { }
